import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import { CustomerQuestion } from '@services/api'
import { AppLanguage } from 'AppTypes'
import i18n from '../../../i18next/i18n'

export const initialState: TAppDetail.State = ({
  isLoading: false,
  isMainAppSidebarOpen: false,
  language: 'jp',
  appErr: [],
  mainNavBarNewQuestionCount: 0
})

export const getNewQuestionCount = createAsyncThunk(
  'customerQuestion/getNewQuestionCount',
  async () => {
    const response = await CustomerQuestion.getNewQuestionCount()
    return response
  }
)

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    switchLanguage: (state, action: PayloadAction<AppLanguage>) => {
      state.language = action.payload
      i18n.changeLanguage(action.payload)
    },
    setAppErr (state, action: PayloadAction<TAppDetail.State['appErr'][0]>) {
      const index = state.appErr.findIndex(({ name }) => name === action.payload.name)
      if (index > -1) {
        state.appErr[index] = action.payload
        return
      }
      state.appErr.push(action.payload)
    },
    resetAppErr (state) {
      state.appErr = []
    },
    removeAppErrByNames (state, action: PayloadAction<string[]>) {
      state.appErr = state.appErr.filter(({ name }) => !action.payload.includes(name))
    }
  },
  extraReducers: builder => {
    builder.addCase(getNewQuestionCount.fulfilled, (state, action) => {
      state.mainNavBarNewQuestionCount = action.payload.data
    })
  }
})

export const {
  switchLanguage,
  toggleGlobalLoading,
  setAppErr,
  resetAppErr,
  removeAppErrByNames
} = appSlice.actions

export const appReducer = appSlice.reducer
